import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Model, ValueToCollection, WhenModel } from '@morningtrain/react-resources'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import { Table } from 'widgets/crud'
import CookieFilter from "support/filters/CookieFilter";

export default function DailyReportWidget () {
  return (
    <Widget>
      <Model resourceName='economy' operationName='daily_overview'>
        <CookieFilter name='period' cookieKey='page.filters.period' />

        <WhenModel>
          <Translator namespace='economy.daily_report'>
            <UI.Card tight className='pt-6 sm:pt-10'>

              <UI.CardHeader withPadding>
                <UI.WithSubtitle subtitle={(
                  <UI.Text uppercase size='xs'>
                    <Displays.Text name='meta.date' />
                  </UI.Text>
              )}
                >
                  <UI.Text weight='medium' size='lg'>
                    <Translation name='title' />
                  </UI.Text>
                </UI.WithSubtitle>
              </UI.CardHeader>
              <ValueToCollection name='collection'>
                <Table
                  className='border-t'
                  striped
                  withFooter
                  extraHeader={(
                    <tr>
                      <th />
                      <th colSpan={4}>
                        <Translation name='generic.revenue' />
                      </th>
                      <th colSpan={3} className='border-l'>
                        <Translation name='generic.wage_ratio' />
                      </th>
                      <th colSpan={3} className='border-l'>
                        <Translation name='generic.guest_count' />
                      </th>
                    </tr>
              )}
                >
                  <Columns.Text
                    name='name'
                    footer={<Translation name='generic.total' />}
                  />
                  <Columns.Number
                    alignment='right'
                    name='revenue_realized'
                    label={<Translation name='columns.realized' />}
                    aggregate='sum'
                    decimals={0}
                  />
                  <Columns.Number
                    alignment='right'
                    name='revenue_deviation_to_budget'
                    label={<Translation name='columns.revenue_deviation_to_budget' />}
                    aggregate='sum'
                    decimals={0}
                  />
                  <Columns.Number
                    alignment='right'
                    name='revenue_deviation_to_budget_mtd'
                    label={<Translation name='columns.revenue_deviation_to_budget_mtd' />}
                    aggregate='sum'
                    decimals={0}
                  />
                  <Columns.Number
                    alignment='right'
                    name='revenue_week_to_date'
                    label={<Translation name='generic.week_to_date' />}
                    aggregate='sum'
                    decimals={0}
                  />
                  <Columns.Column
                    className='border-l'
                    alignment='right'
                    label={<Translation name='columns.realized' />}
                    footer={(
                      <Displays.AggregateRatio
                        name='wage_ratio_salary'
                        outOfName='wage_ratio_revenue'
                        display={(
                          <Displays.WageRatio />
                        )}
                      />
                    )}
                  >
                    <Displays.WageRatio name='wage_ratio_realized' />
                  </Columns.Column>
                  <Columns.Column
                    alignment='right'
                    footer={(
                      <Displays.AggregateRatio
                        name='budgeted_wage_ratio_expenses'
                        outOfName='budgeted_wage_ratio_revenue'
                        display={(
                          <Displays.WageRatio />
                        )}
                      />
                    )}
                    label={<Translation name='columns.shifts_plan' />}
                  >
                    <Displays.WageRatio
                      name='wage_ratio_expected'
                    />
                  </Columns.Column>
                  <Columns.Column
                    label='MTD'
                    alignment='right'
                    footer={(
                      <Displays.AggregateRatio
                        name='wage_ratio_salary_mtd'
                        outOfName='wage_ratio_revenue_mtd'
                        display={(
                          <Displays.WageRatio />
                        )}
                      />
                    )}
                  >
                    <Displays.WageRatio
                      name='wage_ratio_month_to_date'
                    />
                  </Columns.Column>

                  <Columns.Number
                    decimals={0}
                    className='border-l'
                    alignment='right'
                    label={<Translation name='columns.realized' />}
                    aggregate='sum'
                    name='guest_count_realized'
                  />
                  <Columns.Number
                    decimals={0}
                    alignment='right'
                    label={<Translation name='columns.expected' />}
                    aggregate='sum'
                    name='guest_count_expected'
                  />
                  <Columns.Column
                    display={(
                      <Displays.Percentage
                        decimals={0}
                        badBelow={0}
                        positiveColor='green'
                      />
                    )}
                    alignment='right'
                    name='guest_count_comparison'
                    footer={(
                      <Displays.AggregateChange
                        name='guest_count_realized_mtd'
                        outOfName='guest_count_realized_mtd_ly'
                        display={(
                          <Displays.Percentage
                            decimals={0}
                            badBelow={0}
                            positiveColor='green'
                          />
                        )}

                      />
                    )}
                    label={<Translation name='columns.guest_count_comparison' />}
                  />
                </Table>
              </ValueToCollection>

            </UI.Card>
          </Translator>
        </WhenModel>
      </Model>
    </Widget>
  )
}
